import type { FC, ReactNode } from "react";
import { styled } from "@mui/material/styles";
import { MobileDetector } from "../components/mobile-detector";

interface MainLayoutProps {
  children?: ReactNode;
}

export const MainLayout: FC<MainLayoutProps> = ({ children }) => {
  const MainLayoutRoot = styled("div")(({ theme: _theme }) => ({}));

  return (
    <MainLayoutRoot>
      <MobileDetector />
      {/* <MainNavBar /> */}
      {/* <MainSidebar
        onClose={(): void => setIsSidebarOpen(false)}
        open={isSidebarOpen}
      /> */}
      {children}
      {/* <Footer /> */}
    </MainLayoutRoot>
  );
};
